import Vue from "vue";
import VueRouter from "vue-router";
import InfoIndexView from "../components/info/InfoIndexView.vue";
import CoordinatorIndexView from "../components/coordinator/CoordinatorIndexView.vue";
import MyEdu from "../components/myedu/MyEdu.vue";
import HomeView from "@/components/admin/HomeView";
import PreuzimanjeIdentiteta from "@/components/others/PreuzimanjeIdentiteta"
import Cards from "@/components/cards/CardsPreview"
import LanguageMyEdu from "@/components/language/LanguageMyEdu";
import LanguageHomePage from "@/components/language/LanguageHomePage";
import LanguageCoordinator from "@/components/language/LanguageCoordinator";
import LanguagePreuzimanjeIdentiteta from "@/components/language/LanguagePreuzimanjeIdentiteta";
import LanguageUserProfile from "@/components/language/LanguageUserProfile";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "InfoIndexView",
        component: InfoIndexView
    },

    {
        path: "/moj-eduid",
        name: "MyEdu",
        component: MyEdu
    },
    {
        path: "/:lang/moj-eduid",
        name: "LanguageMyEdu",
        component: LanguageMyEdu
    },
    {
        path: "/korisnik",
        name: "HomeView",
        component: HomeView
    },
    {
        path: "/:lang/korisnik",
        name: "LanguageUserProfile",
        component: LanguageUserProfile
    },
    {
        path: "/koordinatori",
        name: "CoordinatorIndexView",
        component: CoordinatorIndexView
    },
    {
        path: "/:lang/koordinatori",
        name: "LanguageCoordinator",
        component: LanguageCoordinator
    },
    {
        path: "/preuzimanje-identiteta",
        name: "PreuzimanjeIdentiteta",
        component: PreuzimanjeIdentiteta
    },
    {
        path: "/:lang/preuzimanje-identiteta",
        name: "LanguagePreuzimanjeIdentiteta",
        component: LanguagePreuzimanjeIdentiteta
    },
    {
        path: "/cards/:card_num",
        name: "Cards",
        component: Cards
    },
    {
        path: "/:lang",
        name: "LanguageHomePage",
        component: LanguageHomePage
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
